import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { AppColors, SessionService, SessionUser } from "src/app/core";
import { PopoverService } from "src/app/shared";
import { ShadowWidgetUrlPopupComponent } from "../shadow-widget-url-popup/shadow-widget-url-popup.component";

@Component({
    selector: "app-shadow-widget",
    templateUrl: "./shadow-widget.component.html",
    styleUrls: ["./shadow-widget.component.scss"],
    standalone: false
})
export class ShadowWidgetComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<void> = new Subject<void>();
  @ViewChild("linkButton", { read: ElementRef }) linkButton: ElementRef;

  user: SessionUser;
  shadower: SessionUser;

  constructor(private sessionService: SessionService, private popoverService: PopoverService) {}

  ngOnInit(): void {
    this.sessionService.sessionUser$.pipe(takeUntil(this._destroy$)).subscribe(user => {
      this.user = user;
      this.shadower = user.shadower;
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  onLinkClick($event: MouseEvent): void {
    $event.stopPropagation();
    this.popoverService.open(ShadowWidgetUrlPopupComponent, this.linkButton.nativeElement, {
      topBorderColor: AppColors.Accent,
      animate: true,
      position: "bottom-right",
      flexibleDimensions: true,
    });
  }
}
